import _defineProperty from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import popMixin from '@/mixin/pop';
import lotteryMixin from '@/mixin/lottery';
import 'swiper/swiper-bundle.css';
var 已中奖素材 = window.setting.抽奖模块.已中奖素材;
export default {
  mixins: [popMixin, lotteryMixin],
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide
  },
  data: function data() {
    return {
      swiperOptions: {
        loop: false,
        direction: 'horizontal',
        autoplay: false,
        speed: 800,
        slidesPerView: 'auto',
        centeredSlides: true
      }
    };
  },
  props: {
    // 奖品列表
    data: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState(['boostList', 'boostedList'])), {}, {
    // 倒序分享助力列表
    userList: function userList() {
      var boostedList = this.boostedList.map(function (_ref) {
        var avatar = _ref.avatar,
            nick = _ref.nick;
        return {
          user_icon: avatar,
          user_name: nick
        };
      });
      var list = this.data.index === 0 ? boostedList : this.boostList;
      return _toConsumableArray(list).reverse();
    },
    // 中奖映射表
    lotteryHitMaterial: function lotteryHitMaterial() {
      return 已中奖素材.reduce(function (total, cur) {
        return _objectSpread(_objectSpread({}, total), {}, _defineProperty({}, cur.奖品id, cur.文案));
      }, {});
    }
  }),
  methods: {
    share: function share(item) {
      var result = item.result,
          lottery = item.lottery;

      if (result) {
        this.eventBus.$emit('launchShare', {
          type: 'lottery',
          prizeName: lottery.lotter_name,
          prizeIcon: lottery.lotter_url
        }, this.close);
      } else {
        this.eventBus.$emit('launchShare', {
          type: 'bless',
          prizeIcon: lottery.分享图
        }, this.close);
      }
    }
  }
};